export const SET_SAMPLES = 'SET_SAMPLES'
export const RESET_SAMPLES_ACTION = 'RESET_SAMPLES_ACTION'
export const SET_SAMPLE = 'SET_SAMPLE'
export const SET_COMPARE_SAMPLES = 'SET_COMPARE_SAMPLES'
export const PENDING_SAMPLES_ACTION = 'PENDING_SAMPLES_ACTION'
export const COMPLETED_SAMPLES_ACTION = 'COMPLETED_SAMPLES_ACTION'
